/**
 * @file
 * Kit button; a confirm option opens the confirmation popover.
 */

((Drupal) => {
  const { berTags } = Drupal;
  const { confirm } = berTags;
  const { el } = berTags.dom;
  const ui = Drupal.berUI;
  const { base } = ui.compose;

  // A button; a confirm message turns the click into the little
  // confirmation popover (e.g. delete confirmation).
  ui.button = ({
    label = '',
    classes = '',
    confirm: confirmMessage = '',
    onClick,
  } = {}) => {
    const node = el('button', classes);
    node.type = 'button';
    if (label) {
      node.textContent = label;
    }
    if (onClick) {
      node.addEventListener('click', () => {
        if (confirmMessage) {
          confirm.open(
            node,
            typeof confirmMessage === 'function'
              ? confirmMessage()
              : confirmMessage,
            onClick,
          );
        } else {
          onClick();
        }
      });
    }
    const api = base(node);
    ui.emit('button', { component: api });
    return api;
  };

  ui.register('button', ui.button);
})(Drupal);
